import {
  APIServiceAccount,
  APIServiceAccountUser,
  APIToken,
  ArdoqId,
  CreateServiceAccountAndTokenPayload,
  OrgAccessLevel,
} from '@ardoq/api-types';
import { ApiResponse } from './types';
import {
  Method,
  fetchJson,
  headers,
  toRequestOptions,
  fetchVoidAndRespondWithId,
} from './api';

const fetchServiceAccounts = (): ApiResponse<APIServiceAccount[]> => {
  const request = new Request('/api/user/service-account', { headers });
  return fetchJson<APIServiceAccount[]>(request);
};

const createServiceAccount = (
  name: string,
  role: OrgAccessLevel
): ApiResponse<APIServiceAccountUser> => {
  const request = new Request(
    '/api/user/service-account',
    toRequestOptions(Method.POST, { name, role })
  );
  return fetchJson<APIServiceAccountUser>(request);
};

const createTokenForServiceAccount = (
  userId: string,
  description: string
): ApiResponse<APIToken> => {
  const request = new Request(
    '/api/token/org/service-account-token',
    toRequestOptions(Method.POST, {
      'user-id': userId,
      type: 'api',
      description,
    })
  );
  return fetchJson<APIToken>(request);
};

const createServiceAccountAndToken = ({
  name,
  role,
  tokenDescription,
}: CreateServiceAccountAndTokenPayload): ApiResponse<APIServiceAccount> => {
  const request = new Request(
    '/api/user/service-account-and-token',
    toRequestOptions(Method.POST, { name, role, tokenDescription })
  );
  return fetchJson<APIServiceAccount>(request);
};

const deleteServiceAccount = async (id: ArdoqId): ApiResponse<ArdoqId> => {
  const request = new Request(
    `/api/user/service-account`,
    toRequestOptions(Method.DELETE, { userId: id })
  );
  return fetchVoidAndRespondWithId(request, id);
};

export const serviceAccountApi = {
  fetchServiceAccounts,
  createServiceAccount,
  createTokenForServiceAccount,
  createServiceAccountAndToken,
  deleteServiceAccount,
};
